import { render, staticRenderFns } from "./SCardProductSaleComp.vue?vue&type=template&id=1fa51d28&"
import script from "./SCardProductSaleComp.vue?vue&type=script&lang=js&"
export * from "./SCardProductSaleComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports